import { __assign, __awaiter, __generator } from "tslib";
import { axios } from '../axios';
function postCampaigns(_a) {
    var clientId = _a.clientId, sessionId = _a.sessionId, domainScopedSessionId = _a.domainScopedSessionId, version = _a.version, device = _a.device, userId = _a.userId, campaigns = _a.campaigns, apiUrlConfig = _a.apiUrlConfig, endpoint = _a.endpoint;
    return axios({
        method: 'POST',
        url: "".concat(apiUrlConfig, "/v3/web/").concat(endpoint),
        headers: {
            'X-RMC-Client-ID': clientId,
            'X-RMC-Session': sessionId,
            'X-RMC-GlobalSession': domainScopedSessionId,
            'X-RMC-SDK-Version': version,
            Accept: 'application/json',
        },
        withCredentials: true,
        data: { device: device, user: userId, campaigns: campaigns },
    });
}
function getPreviewCampaign(_a) {
    var clientId = _a.clientId, version = _a.version, device = _a.device, previewQuery = _a.previewQuery, apiUrlConfig = _a.apiUrlConfig, endpoint = _a.endpoint;
    return axios({
        method: 'GET',
        url: "".concat(apiUrlConfig, "/v3/web/").concat(endpoint, "/preview"),
        headers: {
            'X-RMC-Client-ID': clientId,
            'X-RMC-SDK-Version': version,
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        params: __assign({ device: device }, previewQuery),
        withCredentials: true,
    });
}
export function getCampaigns(_a) {
    var device = _a.device, userId = _a.userId, sessionId = _a.sessionId, domainScopedSessionId = _a.domainScopedSessionId, previewQuery = _a.previewQuery, version = _a.version, campaigns = _a.campaigns, clientId = _a.clientId, apiUrlConfig = _a.apiUrlConfig, endpoint = _a.endpoint;
    return __awaiter(this, void 0, void 0, function () {
        var isPreview, isMatchedCampaigns, result, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isPreview = Object.keys(previewQuery).length !== 0;
                    isMatchedCampaigns = campaigns.length;
                    if (!isPreview) return [3 /*break*/, 2];
                    return [4 /*yield*/, getPreviewCampaign({
                            clientId: clientId,
                            version: version,
                            device: device,
                            previewQuery: previewQuery,
                            apiUrlConfig: apiUrlConfig,
                            endpoint: endpoint,
                        })];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, result];
                case 2:
                    if (!(!isPreview && isMatchedCampaigns)) return [3 /*break*/, 4];
                    return [4 /*yield*/, postCampaigns({
                            clientId: clientId,
                            sessionId: sessionId,
                            domainScopedSessionId: domainScopedSessionId,
                            version: version,
                            device: device,
                            userId: userId,
                            campaigns: campaigns,
                            apiUrlConfig: apiUrlConfig,
                            endpoint: endpoint,
                        })];
                case 3:
                    result = _b.sent();
                    return [2 /*return*/, result];
                case 4: return [2 /*return*/, { data: [] }];
            }
        });
    });
}
